import { useMemo } from 'react';
import { store } from 'redux/store';
import { useSelector } from 'react-redux';
import {
  setModelPeriods as setModelPeriodsRedux,
  selectMWComparatorControlPanelModelPeriods,
} from 'redux/reducers/meteorologyWeatherComparatorControlPanelReducer';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';
import { format, parse } from 'date-fns';

export default function usePeriod({ modelIndex, accordionId }: {
  modelIndex: number;
  accordionId: string;
}) {
  const modelPeriods = useSelector(selectMWComparatorControlPanelModelPeriods);
  const closeAccordion = useMemo(() => buildAccordionClickFunction(accordionId), [accordionId]);
  const minDate = new Date();

  const getModelPeriod = () => {
    const startDate = modelPeriods[modelIndex].startDate !== ''
      ? parse(modelPeriods[modelIndex].startDate, 'yyyy-MM', new Date())
      : undefined;
    const endDate = modelPeriods[modelIndex].endDate !== ''
      ? parse(modelPeriods[modelIndex].endDate, 'yyyy-MM', new Date())
      : undefined;
    return { startDate, endDate };
  };

  const setModelPeriod = (period: { startDate: string; endDate: string }) => {
    const newModelPeriods = [...modelPeriods];
    newModelPeriods[modelIndex] = period;
    store.dispatch(setModelPeriodsRedux(newModelPeriods));
  };

  const changePeriod = (dates) => {
    const [startDate, endDate] = dates;
    const stringStartDate = startDate ? format(startDate, 'yyyy-MM') : '';
    const stringEndDate = endDate ? format(endDate, 'yyyy-MM') : '';
    setModelPeriod({ startDate: stringStartDate, endDate: stringEndDate });
    if (startDate && endDate) {
      closeAccordion();
    }
  };

  return {
    getModelPeriod,
    changePeriod,
    minDate,
  };
}
